<template>

    <div class="impersonate-bar">
        <div style="float:left;">
            ID STORE: {{ idStore }}
        </div>
        <div style="float:right;">
            {{ impersonateMail }}
            <v-btn icon color="pink" @click="exorcise">
                <v-icon>mdi-exit-to-app</v-icon>
            </v-btn>
        </div>
    </div>
</template>

<script>
    import { UrlBundles, UserInfo, EventHub } from "Libs/core";
    import axios from "axios";

    export default {
        data() {
            return {
                axios: axios,
                eventHub: EventHub,
                impersonateMail: window.ADMIN_INFO.ImpersonateEmail,
                idStore: window.USER_INFO.currentStoreId,
                urlBundles: UrlBundles,
                userInfo: UserInfo,
            };
        },
        methods: {
            exorcise() {
                axios
                    .put(this.urlBundles.adminApi + "/RemoveImpersonateUser")
                    .then(() => {
                        localStorage.clear();
                        window.location.href = this.urlBundles.refreshSignIn;
                    });
            },
        },
        mounted() {
            if (this.impersonateMail && this.impersonateMail !== "") {
                document.body.classList.add("impersonate-mode");
            }
        },
    };
</script>

<style lang="scss">
    body.impersonate-mode {
        .v-main {
            margin-top: 30px;
        }
    }

    .impersonate-bar {
        height: 30px;
        color: #fff;
        background: #000;
        padding: 0 20px;
        text-align: right;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 9999;
    }
</style>